var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGear2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04424 15.5306L8.48276 16.5169C8.74908 17.1167 9.34379 17.5031 10.0001 17.5031V17.5031C10.6563 17.5031 11.251 17.1167 11.5174 16.5169L11.9559 15.5306C12.112 15.1807 12.3745 14.8889 12.7062 14.697V14.697C13.0399 14.5045 13.426 14.4225 13.8091 14.4627L14.8821 14.5769C15.5346 14.6459 16.1665 14.3241 16.4944 13.7557V13.7557C16.8227 13.1877 16.7855 12.4796 16.3994 11.9492L15.7641 11.0763C15.5379 10.7632 15.4171 10.3863 15.419 10V10C15.4189 9.61479 15.5409 9.23946 15.7675 8.9279L16.4027 8.05504C16.7888 7.52461 16.8261 6.81646 16.4978 6.24845V6.24845C16.1699 5.6801 15.5379 5.35826 14.8854 5.42727L13.8125 5.54149C13.4293 5.58173 13.0432 5.49973 12.7095 5.30722V5.30722C12.3772 5.11417 12.1146 4.82087 11.9592 4.46938L11.5174 3.48313C11.251 2.88334 10.6563 2.49689 10.0001 2.49689V2.49689C9.34379 2.49689 8.74908 2.88334 8.48276 3.48313L8.04424 4.46938C7.88887 4.82087 7.62622 5.11417 7.29393 5.30722V5.30722C6.9602 5.49973 6.57413 5.58173 6.19097 5.54149L5.11469 5.42727C4.46218 5.35826 3.83025 5.6801 3.50235 6.24845V6.24845C3.17403 6.81646 3.21128 7.52461 3.59739 8.05504L4.23265 8.9279C4.4592 9.23946 4.5812 9.61479 4.58113 10V10C4.5812 10.3852 4.4592 10.7606 4.23265 11.0721L3.59739 11.945C3.21128 12.4754 3.17403 13.1836 3.50235 13.7516V13.7516C3.83055 14.3196 4.46226 14.6413 5.11469 14.5727L6.18763 14.4585C6.5708 14.4183 6.95687 14.5003 7.29059 14.6928V14.6928C7.62413 14.8853 7.888 15.1787 8.04424 15.5306V15.5306Z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0001,
    cy: 10,
    r: 2.20675,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGear2);
export default ForwardRef;